import { registerLocaleData } from "@angular/common";
import localeFr from "@angular/common/locales/fr";
import { bootstrapApplication } from "@angular/platform-browser";
import { browserTracingIntegration, init, replayIntegration } from "@sentry/angular";
import { AppComponent } from "./app/app.component";
import { appConfig } from "./app/app.config";
import { environment } from "./environments/environment.development";

registerLocaleData(localeFr, "fr");

init({
    ...environment.sentry,
    integrations: [browserTracingIntegration(), replayIntegration()]
});

bootstrapApplication(AppComponent, appConfig).catch((err) => console.error(err));
